import { PreloaderView } from 'es6/views/preloader-view'

/**
 * Глобальный вид для preloader.
 */
export const preloader = new PreloaderView()
